import { render } from "./index.vue?vue&type=template&id=6d1dfc3f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/customers/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d1dfc3f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d1dfc3f', __exports__)) {
    console.log('reload')
    api.reload('6d1dfc3f', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6d1dfc3f", () => {
    console.log('re-render')
    api.rerender('6d1dfc3f', render)
  })

}


export default __exports__